<template>
  <div class="w-full border border-gray-200 rounded-lg bg-[var(--fundoApp)]">
    <div
      class="px-3 py-2 border-b border-gray-200 sticky top-0 bg-[var(--fundoApp)] z-10"
    >
      <div class="flex items-center flex-wrap gap-1">
        <button
          @click="editor?.chain().focus().toggleBold().run()"
          :class="{ 'bg-gray-200': editor?.isActive('bold') }"
          type="button"
          title="Negrito"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 5h4.5a3.5 3.5 0 1 1 0 7H8m0-7v7m0-7H6m2 7h6.5a3.5 3.5 0 1 1 0 7H8m0-7v7m0 0H6"
            />
          </svg>
        </button>

        <button
          @click="editor?.chain().focus().toggleItalic().run()"
          :class="{ 'bg-gray-200': editor?.isActive('italic') }"
          type="button"
          title="Itálico"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m8.874 19 6.143-14M6 19h6.33m-.66-14H18"
            />
          </svg>
        </button>

        <button
          @click="editor?.chain().focus().toggleUnderline().run()"
          :class="{ 'bg-gray-200': editor?.isActive('underline') }"
          type="button"
          title="Sublinhado"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-width="2"
              d="M6 19h12M8 5v9a4 4 0 0 0 8 0V5M6 5h4m4 0h4"
            />
          </svg>
        </button>

        <button
          @click="editor?.chain().focus().toggleStrike().run()"
          :class="{ 'bg-gray-200': editor?.isActive('strike') }"
          type="button"
          title="Rasurado"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 6.2V5h12v1.2M7 19h6m.2-14-1.677 6.523M9.6 19l1.029-4M5 5l6.523 6.523M19 19l-7.477-7.477"
            />
          </svg>
        </button>

        <button
          @click="editor?.chain().focus().toggleHighlight().run()"
          :class="{ 'bg-gray-200': editor?.isActive('highlight') }"
          type="button"
          title="Realçar"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-width="2"
              d="M9 19.2H5.5c-.3 0-.5-.2-.5-.5V16c0-.2.2-.4.5-.4h13c.3 0 .5.2.5.4v2.7c0 .3-.2.5-.5.5H18m-6-1 1.4 1.8h.2l1.4-1.7m-7-5.4L12 4c0-.1 0-.1 0 0l4 8.8m-6-2.7h4m-7 2.7h2.5m5 0H17"
            />
          </svg>
        </button>

        <button
          @click="editor?.chain().focus().toggleCode().run()"
          :class="{ 'bg-gray-200': editor?.isActive('code') }"
          type="button"
          title="Código"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m8 8-4 4 4 4m8 0 4-4-4-4m-2-3-4 14"
            />
          </svg>
        </button>

        <div class="relative" @click.stop>
          <button
            @click="showColorDropdown = !showColorDropdown"
            type="button"
            title="Cor do texto"
            class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
          >
            <svg
              class="w-4 h-4"
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              fill="none"
              viewBox="0 0 25 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-width="2"
                d="m6.532 15.982 1.573-4m-1.573 4h-1.1m1.1 0h1.65m-.077-4 2.725-6.93a.11.11 0 0 1 .204 0l2.725 6.93m-5.654 0H8.1m.006 0h5.654m0 0 .617 1.569m5.11 4.453c0 1.102-.854 1.996-1.908 1.996-1.053 0-1.907-.894-1.907-1.996 0-1.103 1.907-4.128 1.907-4.128s1.909 3.025 1.909 4.128Z"
              />
            </svg>
          </button>
          <div
            v-if="showColorDropdown"
            class="absolute top-full left-0 z-10 w-48 rounded-sm bg-white p-2 shadow-sm mt-1"
          >
            <div class="grid grid-cols-6 gap-1 mb-3">
              <button
                v-for="color in colorPalette"
                :key="color"
                type="button"
                @click="setTextColor(color)"
                :style="{ backgroundColor: color }"
                :title="`Aplicar cor ${color}`"
                class="w-6 h-6 rounded-md border border-gray-300 hover:scale-110 transition-transform"
              ></button>
            </div>
          </div>
        </div>

        <div class="mx-1" v-if="enableTable">
          <span class="block w-px h-4 bg-gray-300"></span>
        </div>

        <button
        v-if="enableTable"
          @click="
            editor
              ?.chain()
              .focus()
              .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
              .run()
          "
          type="button"
          title="Inserir Tabela"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
            />
          </svg>
        </button>

        <template v-if="editor?.isActive('table')">
          <div class="mx-1 block w-px h-4 bg-gray-300"></div>

          <button
            @click="editor.chain().focus().addColumnAfter().run()"
            class="p-1.5 text-blue-600 hover:bg-blue-50 rounded"
            title="Adicionar Coluna"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path stroke-width="2" d="M12 4v16m8-8H4m16-8v16M4 4v16" />
            </svg>
          </button>
          <button
            @click="editor.chain().focus().addRowAfter().run()"
            class="p-1.5 text-blue-600 hover:bg-blue-50 rounded"
            title="Adicionar Linha"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              style="transform: rotate(90deg)"
            >
              <path stroke-width="2" d="M12 4v16m8-8H4m16-8v16M4 4v16" />
            </svg>
          </button>

          <button
            @click="editor.chain().focus().deleteColumn().run()"
            class="p-1.5 text-orange-600 hover:bg-orange-50 rounded"
            title="Remover Coluna"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12m-9-9h1V4h-1v5zm4 0h1V4h-1v5z"
              />
            </svg>
          </button>
          <button
            @click="editor.chain().focus().deleteRow().run()"
            class="p-1.5 text-orange-600 hover:bg-orange-50 rounded"
            title="Remover Linha"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              style="transform: rotate(90deg)"
            >
              <path
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12m-9-9h1V4h-1v5zm4 0h1V4h-1v5z"
              />
            </svg>
          </button>

          <button
            @click="editor.chain().focus().deleteTable().run()"
            class="p-1.5 text-red-600 hover:bg-red-50 rounded"
            title="Apagar Tabela Inteira"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </button>
        </template>

        <div class="mx-1">
          <span class="block w-px h-4 bg-gray-300"></span>
        </div>

        <button
          @click="editor?.chain().focus().setTextAlign('left').run()"
          :class="{ 'bg-gray-200': editor?.isActive({ textAlign: 'left' }) }"
          type="button"
          title="Alinhar à esquerda"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 6h8m-8 4h12M6 14h8m-8 4h12"
            />
          </svg>
        </button>
        <button
          @click="editor?.chain().focus().setTextAlign('center').run()"
          :class="{ 'bg-gray-200': editor?.isActive({ textAlign: 'center' }) }"
          type="button"
          title="Alinhar ao centro"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 6h8M6 10h12M8 14h8M6 18h12"
            />
          </svg>
        </button>
        <button
          @click="editor?.chain().focus().setTextAlign('right').run()"
          :class="{ 'bg-gray-200': editor?.isActive({ textAlign: 'right' }) }"
          type="button"
          title="Alinhar à direita"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M18 6h-8m8 4H6m12 4h-8m8 4H6"
            />
          </svg>
        </button>

        <div class="mx-1">
          <span class="block w-px h-4 bg-gray-300"></span>
        </div>

        <button
          @click="editor?.chain().focus().toggleBulletList().run()"
          :class="{ 'bg-gray-200': editor?.isActive('bulletList') }"
          type="button"
          title="Lista não numerada"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-width="2"
              d="M9 8h10M9 12h10M9 16h10M4.99 8H5m-.02 4h.01m0 4H5"
            />
          </svg>
        </button>

        <button
          @click="editor?.chain().focus().toggleOrderedList().run()"
          :class="{ 'bg-gray-200': editor?.isActive('orderedList') }"
          type="button"
          title="Lista numerada"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 6h8m-8 6h8m-8 6h8M4 16a2 2 0 1 1 3.321 1.5L4 20h5M4 5l2-1v6m-2 0h4"
            />
          </svg>
        </button>

        <button
          @click="editor?.chain().focus().toggleBlockquote().run()"
          :class="{ 'bg-gray-200': editor?.isActive('blockquote') }"
          type="button"
          title="Citação"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              fill-rule="evenodd"
              d="M6 6a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a3 3 0 0 1-3 3H5a1 1 0 1 0 0 2h1a5 5 0 0 0 5-5V8a2 2 0 0 0-2-2H6Zm9 0a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a3 3 0 0 1-3 3h-1a1 1 0 1 0 0 2h1a5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3Z"
              clip-rule="evenodd"
            />
          </svg>
        </button>

        <button
          @click="editor?.chain().focus().setHorizontalRule().run()"
          type="button"
          title="Linha horizontal"
          class="p-1.5 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-width="2"
              d="M5 12h14"
            />
          </svg>
        </button>
      </div>
    </div>

    <div
      class="px-4 py-2 bg-white rounded-b-lg overflow-auto"
      :style="resizable
        ? { minHeight: height, resize: 'vertical' }
        : { height: height }"
    >
      <EditorContent :editor="editor" class="max-w-none h-full" />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from "vue";
import { Editor, EditorContent } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import { Color } from "@tiptap/extension-color";
import { TextStyle } from "@tiptap/extension-text-style";

// TABLE EXTENSIONS
import { Table } from "@tiptap/extension-table";
import { TableRow } from "@tiptap/extension-table-row";
import { TableHeader } from "@tiptap/extension-table-header";
import { TableCell } from "@tiptap/extension-table-cell";

const props = defineProps({
  modelValue: { type: String, default: "" },
  placeholder: { type: String, default: "Start typing..." },
  height: { type: String, default: "200px" },
  enableTable: { type: Boolean, default: false },
  resizable: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue"]);

const editor = ref(null);
const showColorDropdown = ref(false);
const showFormatDropdown = ref(false);

const colorPalette = [
  "#1A56DB",
  "#0E9F6E",
  "#FACA15",
  "#F05252",
  "#FF8A4C",
  "#0694A2",
  "#B4C6FC",
  "#8DA2FB",
  "#5145CD",
  "#771D1D",
  "#FCD9BD",
  "#99154B",
  "#7E3AF2",
  "#CABFFD",
  "#D61F69",
  "#F8B4D9",
  "#F6C196",
  "#A4CAFE",
  "#5145CD",
  "#B43403",
  "#FCE96A",
  "#1E429F",
  "#768FFD",
  "#BCF0DA",
  "#EBF5FF",
  "#16BDCA",
  "#E74694",
  "#83B0ED",
  "#03543F",
  "#111928",
  "#4B5563",
  "#6B7280",
  "#D1D5DB",
  "#F3F4F6",
  "#F9FAFB",
  "#000000",
];

// Custom TableCell for Background Color Support
const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      backgroundColor: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-background-color"),
        renderHTML: (attributes) => {
          if (!attributes.backgroundColor) return {};
          return {
            "data-background-color": attributes.backgroundColor,
            style: `background-color: ${attributes.backgroundColor}`,
          };
        },
      },
    };
  },
});

const setTextColor = (color) => {
  if (!editor.value) return;
  editor.value.chain().focus().setColor(color).run();
  showColorDropdown.value = false;
};

const closeDropdowns = () => {
  showColorDropdown.value = false;
  showFormatDropdown.value = false;
};

onMounted(() => {
  const extensions = [
    StarterKit.configure({
      heading: { levels: [1, 2, 3, 4, 5, 6] },
      bulletList: { keepMarks: true, keepAttributes: false },
      orderedList: { keepMarks: true, keepAttributes: false },
    }),
    TextStyle,
    Color,
    Underline,
    Highlight.configure({ multicolor: true }),
    TextAlign.configure({ types: ["heading", "paragraph"] }),
  ];

  // Conditionally add table extensions
  if (props.enableTable) {
    extensions.push(
      Table.configure({ resizable: true }),
      TableRow,
      TableHeader,
      CustomTableCell
    );
  }

  editor.value = new Editor({
    extensions,
    content: props.modelValue,
    editorProps: {
      attributes: {
        class:
          "block w-full px-0 text-sm border-0 focus:ring-0 outline-none min-h-[150px]",
        style: "background-color: #ffffff; color: #000000;",
      },
    },
    onUpdate: ({ editor }) => {
      emit("update:modelValue", editor.getHTML());
    },
  });

  document.addEventListener("click", closeDropdowns);
});

onBeforeUnmount(() => {
  if (editor.value) editor.value.destroy();
  document.removeEventListener("click", closeDropdowns);
});

watch(
  () => props.modelValue,
  (newValue) => {
    if (editor.value) {
      if (editor.value.getHTML() !== newValue) {
        editor.value.commands.setContent(newValue, false);
      }
    }
  },
);
</script>

<style scoped>
/* Keep all your original styles */
:deep(.ProseMirror) {
  outline: none;
  color: #000000;
}
:deep(.ProseMirror p:not([style*="color"])) {
  color: #000000;
}
:deep(.ProseMirror ul) {
  padding-left: 1.5rem;
  list-style-type: disc;
}
:deep(.ProseMirror ol) {
  padding-left: 1.5rem;
  list-style-type: decimal;
}
:deep(.ProseMirror blockquote) {
  border-left: 3px solid var(--corTexto);
  padding-left: 1rem;
}

/* TABLE STYLES (REQUIRED FOR TABLES TO BE VISIBLE) */
:deep(.ProseMirror table) {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 1rem 0;
  overflow: hidden;
}
:deep(.ProseMirror td),
:deep(.ProseMirror th) {
  min-width: 1em;
  border: 1px solid #ced4da;
  padding: 6px 8px;
  position: relative;
  box-sizing: border-box;
}
:deep(.ProseMirror th) {
  background-color: #f8f9fa;
  font-weight: bold;
}
:deep(.ProseMirror .selectedCell:after) {
  z-index: 2;
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(200, 200, 255, 0.4);
  pointer-events: none;
}
:deep(.ProseMirror .column-resize-handle) {
  position: absolute;
  right: -2px;
  top: 0;
  bottom: -2px;
  width: 4px;
  background-color: #3b82f6;
  pointer-events: none;
}
</style>
